import { render, staticRenderFns } from "./customerSearch.vue?vue&type=template&id=52a190ea&scoped=true&"
import script from "./customerSearch.vue?vue&type=script&lang=js&"
export * from "./customerSearch.vue?vue&type=script&lang=js&"
import style0 from "./customerSearch.vue?vue&type=style&index=0&id=52a190ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a190ea",
  null
  
)

export default component.exports